export const es = {
  sidebar: {
    collapse: 'Contraer',
    expand: 'Expandir',
    settings: 'Configuración',
    auditLog: 'Registro de Auditoría',
  },

  signIn: {
    emailField: {
      label: 'Correo electrónico',
      placeholder: 'Tu correo electrónico',
    },
    passwordField: {
      label: 'Contraseña',
      placeholder: 'Tu contraseña',
    },
    submit: 'Continuar',

    or: 'O',
    noAccount: '¿No tienes una cuenta?',
    bookDemo: '¡Agenda una demostración!',

    errors: {
      invalid:
        'Credenciales inválidas. Verifica tu correo/contraseña e intenta de nuevo.',
    },

    success: '¡Inicio de sesión exitoso!',
  },

  orgSelection: {
    title: 'Seleccionar Organización',
    subtitle: 'Elige la organización a la que deseas acceder',

    orgField: {
      label: 'Seleccionar Organización',
      placeholder: 'Seleccionar Organización',
    },

    submit: 'Continuar',
    goBack: 'Volver al Inicio de Sesión',

    errors: {
      invalid:
        'Selección de organización inválida. Por favor, intenta de nuevo.',
    },
  },

  totp: {
    title: 'Autenticación de Dos Factores',
    subtitle:
      'Ingresa el código de 6 dígitos de tu aplicación de autenticación',
    qrSetup: {
      title: 'Escanea este código QR con tu aplicación de autenticación',
    },
    submit: {
      verify: 'Verificar Código',
      setup: 'Completar Configuración',
    },
    goBack: 'Volver al Inicio de Sesión',
    errors: {
      invalid: 'Código de verificación inválido. Por favor, intenta de nuevo.',
    },
  },

  emailVerification: {
    title: 'Verifica tu Correo Electrónico',
    subtitle: 'Ingresa el código de 6 dígitos enviado a tu correo electrónico',
    submit: 'Verificar Código',
    goBack: 'Volver al Inicio de Sesión',
    errors: {
      invalid: 'Código de verificación inválido. Por favor, intenta de nuevo.',
    },
  },

  sessionRefresh: {
    reconnecting: 'Intentando Reconectar',
    cancel: 'Cancelar',
  },

  versionMismatch: {
    title: 'Nueva Versión Disponible',
    description:
      'La aplicación ha sido actualizada. Por favor, actualiza la página para obtener la última versión.',
    action: 'Actualizar Ahora',
  },

  topbar: {
    signOut: 'Cerrar sesión',
    assistant: 'ReAI',
    facility: 'Instalación',
  },

  address: {
    fields: {
      streetAddress: 'Dirección',
      city: 'Ciudad',
      state: 'Estado',
      postalCode: 'Código Postal',
      country: 'País',
    },
    placeholders: {
      streetAddress: 'Ingresa la dirección',
      city: 'Ingresa la ciudad',
      state: 'Ingresa el estado',
      postalCode: 'Ingresa el código postal',
      country: 'Ingresa el país',
    },
    errors: {
      geocodingFailed:
        'No se pudieron obtener los detalles de la dirección. Por favor, intenta de nuevo.',
    },
  },
};
